import type { JSONContent } from '@tiptap/core';

export interface CommunityAnnouncementMentions {
  everyone: boolean;
  badgeIds: string[];
}

const mentionAttributes = (node: JSONContent): Record<string, unknown>[] =>
  node.type === 'mention' ? [node.attrs ?? {}] : (node.content ?? []).flatMap(mentionAttributes);

export const extractCommunityAnnouncementMentions = (content: JSONContent): CommunityAnnouncementMentions => {
  const mentions = mentionAttributes(content);
  const badgeIds = mentions.flatMap(({ type, id }) => (type === 'badge' && typeof id === 'string' && id ? [id] : []));

  return {
    everyone: mentions.some(({ type }) => type === 'everyone'),
    badgeIds: [...new Set(badgeIds)],
  };
};
